<template>
  <transition name="el-fade-in-linear">
    <div
      v-if="visible && programData"
      ref="preview"
      class="preview"
      @mousewheel.prevent
    >
      <div class="main-area">
        <div
          class="container"
          style="border: 2px solid #fff"
          :style="containerStyle"
        >
          <div class="btns-wrapper">
            <div class="exit" @click="handleExit">
              <!-- {{ $t("lcd.Editor.Exit") }} -->
              <i class="el-icon-close" style="font-size: 20px;"></i>
            </div>
          </div>
          <img :src="src" style="border: 4px solid #ddd" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import store from "../../../store/index.js";

export default {
  name: "Preview",
  components: {},
  data() {
    return {
      state: store.state,
      currentPageIdx: 0,
      containerWidth: null,
      containerHeight: null,
      src: "",
    };
  },
  computed: {
    visible: {
      get() {
        return store.state.previewEslVisible;
      },
      set(val) {
        store.updatePreviewEslVisible(val);
      },
    },
    programData() {
      return store.state.programInfo;
    },
    currentPageComponentList() {
      return this.programData.pages[this.currentPageIdx].componentList;
    },
    containerStyle() {
      if (!this.containerWidth || !this.containerHeight) {
        return {};
      }
      const scaleX = this.containerWidth / this.programData.width;
      const scaleY = this.containerHeight / this.programData.height;
      let top;
      let left;
      if (scaleX <= 1.0) {
        left = "-" + (this.programData.width / 2) * (1 - scaleX) + "px";
      } else {
        left = (this.programData.width / 2) * (scaleX - 1) + "px";
      }
      if (scaleY <= 1.0) {
        top = "-" + (this.programData.height / 2) * (1 - scaleY) + "px";
      } else {
        top = (this.programData.height / 2) * (scaleY - 1) + "px";
      }
      const showScaleX =
        this.containerWidth > this.programData.width
          ? 1
          : this.containerWidth / this.programData.width;
      const showScaleY =
        this.containerHeight > this.programData.height
          ? 1
          : this.containerHeight / this.programData.height;
      const showScale = showScaleX < showScaleY ? showScaleX : showScaleY;
      const style = {
        position: "absolute",
        width: this.programData.width + "px",
        height: this.programData.height + "px",
        background: "#fff",
        transform: `scaleX(${showScale}) scaleY(${showScale})`,
        left,
        top,
        boxSizing: "content-box",
        padding: "20px",
      };
      // if (this.programData.pages[this.currentPageIdx].bgColor) {
      //   style.backgroundColor =
      //     this.programData.pages[this.currentPageIdx].bgColor;
      // }
      // if (this.programData.pages[this.currentPageIdx].bgImg) {
      //   style.backgroundImage = `url(${
      //     this.programData.pages[this.currentPageIdx].bgImg
      //   })`;
      //   style.backgroundSize = "100% 100%";
      // }
      return style;
    },
    preActive() {
      return this.currentPageIdx > 0;
    },
    nextActive() {
      return this.currentPageIdx < this.programData.pages.length - 1;
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.currentPageIdx = 0;
        this.getWH();
        this.src = localStorage.getItem("previewImg");
      }
    },
  },
  created() {
    this.getWH();
  },
  methods: {
    handleExit() {
      store.updatePreviewEslVisible(false);
    },
    getWH() {
      if (!this.$refs.preview) {
        return setTimeout(this.getWH, 1);
      }
      const rect = this.$refs.preview.getBoundingClientRect();
      this.containerWidth = rect.width * 0.8;
      this.containerHeight = rect.height * 0.8;
    },
    handlePre() {
      if (this.preActive) {
        this.currentPageIdx -= 1;
      }
    },
    handleNext() {
      if (this.nextActive) {
        this.currentPageIdx += 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/clearfix";
.preview {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 300;
  background-color: rgba(0, 0, 0, 0.5);
  .main-area {
    position: absolute;
    left: 10%;
    right: 10%;
    top: calc(10% - 22px);
    bottom: calc(10% - 22px);
    .btns-wrapper {
      position: absolute;
      top: 0;
      right: 0;
      font-size: 16px;
      font-weight: bold;
      // transform: translateX(-50%);
      @include clearfix;
      .pre,
      .next,
      .exit {
        // padding: 8px 14px;
        border-radius: 4px;
        cursor: pointer;
        user-select: none;
        &:not(:last-child) {
          margin-right: 8px;
        }
      }
      .pre,
      .next {
        float: left;
        background-color: #808695;
        &.active {
          &:hover {
            background-color: #e3e7ee;
          }
        }
      }
      // .exit {
      //   // float: right;
      //   // color: #fff;
      //   // background-color: #ed4014;
      //   // &:hover {
      //   //   background-color: #f16643;
      //   // }
      // }
      .page-info {
        float: left;
        font-size: 16px;
        // padding: 8px 16px;
        z-index: 300;
        background-color: #fff;
        margin-right: 8px;
        border-radius: 4px;
        .curr {
          color: #f66;
        }
      }
    }
  }
}
</style>
